import React from "react";
import ConversationWall from "./ConversationWall";
import "../aseets/css/ContactConversationPage.css";

import leftIllustration from "../aseets/gallery/contact-left.png";
import rightIllustration from "../aseets/gallery/contact-right.png";
import insta from '../aseets/SocialIcons/IG.png';
import fb from '../aseets/SocialIcons/FB.png';
import linkedin from '../aseets/SocialIcons/IN.png';
import YT from '../aseets/SocialIcons/YT.png';

const ContactConversationPage = () => {
    return (
        <>



            {/* ===============================
          TOP: CONVERSATION WALL LAYOUT
      =============================== */}

            <section className="gm-contact-canvas">

                <img
                    src={leftIllustration}
                    alt="Team illustration"
                    className="gm-contact-illustration left"
                />

                <ConversationWall />

                <img
                    src={rightIllustration}
                    alt="Support illustration"
                    className="gm-contact-illustration right"
                />
            </section>

            {/* ===============================
          BOTTOM: GLOBAL MANCH CONTACT
      =============================== */}
            <section className="gm-contact-details">
                <h2>Get in touch with Global Manch</h2>
                <p>We’re always ready to listen, collaborate and build.</p>

                <div className="gm-contact-grid">
                    {/* MAP */}
                    <div className="gm-contact-map">
                        {/* <iframe
                            title="Global Manch Location"
                            src="https://www.google.com/maps?q=Pune&output=embed"
                            loading="lazy"
                        /> */}

                        <iframe title="Global Manch Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d104499.96246605659!2d73.72819352073049!3d18.53775405312668!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc295005759f761%3A0x68ac92bd3c8645f6!2sSamriddhi%20group!5e1!3m2!1sen!2sin!4v1767355554415!5m2!1sen!2sin" loading="lazy"></iframe>

                    </div>

                    {/* INFO */}
                    <div className="gm-contact-info">
                        <h4>Address</h4>
                        <p>
                            Global Manch<br />
                            Pune, Maharashtra, India
                        </p>

                        <h4>Email</h4>
                        <p>info@globalmanch.com</p>

                        <h4>Phone</h4>
                        <p>+91 9XXXXXXXXX</p>

                        <div className="gm-contact-socials">
                            <span><img src={fb} alt="facebook" ></img></span>
                            <span><img src={insta} alt="Instagram" ></img></span>
                            <span><img src={linkedin} alt="LinkedIn" ></img></span>
                            <span><img src={YT} alt="Youtube" ></img></span>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactConversationPage;
